export default __webpack_public_path__ + "static/media/pl.ac5ea414.png";